<template>
  <div class="p-badge">
    <div class="p-badge-wrapper">
      <span :class="classList">
        <slot name="badge"></slot>
      </span>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      left: { type: Boolean, default: false },
      center: { type: Boolean, default: false },
      bottom: { type: Boolean, default: false },
      color: { type: String, default: 'base' },
      overlap: { type: Boolean, default: false },
      spacious: { type: Boolean, default: false },
      dense: { type: Boolean, default: false },
      noOutline: { type: Boolean, default: false },
    },
    computed: {
      classList() {
        return {
          'p-badge-badge': true,
          [`color-${this.color}`]: this.color,
          top: !this.bottom && !this.center,
          bottom: this.bottom && !this.center,
          right: !this.left,
          center: this.center,
          left: this.left,
          overlap: this.overlap,
          spacious: this.spacious,
          dense: this.dense,
          'no-outline': this.noOutline,
        };
      },
    },
  });
</script>
